const productDescription = ()=>({
    expanded: false,
    isOverflowing: false,
    init(){
        this.checkOverflow();
    },
    toggleDescription(){
        this.expanded = !this.expanded;
    },
    checkOverflow() {
        this.$nextTick(() => {
            const content = this.$refs.description;
            this.isOverflowing = content.scrollHeight >= 72;
        });
    },
})

export default productDescription

window.addEventListener("alpine:init", ()=>{
    Alpine.data("description", productDescription)
})

